'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nameBadge = require('./name-badge.html');

var _nameBadge2 = _interopRequireDefault(_nameBadge);

var _wood = require('./wood.html');

var _wood2 = _interopRequireDefault(_wood);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  "name-badge": _nameBadge2.default,
  wood: _wood2.default

  // WEBPACK FOOTER //

};


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-pricing/templates/name-badges/index.js
 **/